module.exports = __webpack_public_path__ + "static/main_bg_14-3b187b6c63cfeb148c7e748758eb316b.png";